import * as redom from "redom";

import * as dom from "~/lib/dom";
import { colors } from "~/ui";
import { AvatarDOMComponent } from "~/ui/legacy/Avatar";

import type { AttendeeAttrs } from "./Attendees";

export interface AvatarsDOMComponentData {
	viewerId?: string;
	users: Array<AttendeeAttrs>;
	avatarWidth: string;
	isDarkMode: boolean;
}

// Implements, using the DOM API, a subset of the above component needed for
// the notes editor.
export class AvatarsDOMComponent implements dom.DOMComponent<AvatarsDOMComponentData> {
	el: HTMLElement;
	avatarsWrapperElement: HTMLDivElement;

	fallback = "";
	notFound = false;

	constructor(private data: AvatarsDOMComponentData) {
		const { viewerId, avatarWidth, users, isDarkMode } = data;
		this.avatarsWrapperElement = redom.el("div", {
			class: "assignee-avatars",
		});
		// We want to render the viewer first, so let's sort by that
		let usersToRender = [...users];
		usersToRender.sort((a, _b) => (a.id === viewerId ? -1 : 0));
		// We want to render 3 assignees max on desktop
		// The list uses row-reverse, so to keep our order let's reverse the list
		// TODO: Change based on the screen's width
		usersToRender = usersToRender.slice(0, users.length <= 3 ? 3 : 2);
		usersToRender.reverse();
		let userElements: Array<HTMLElement> = [];
		if (users.length > usersToRender.length) {
			userElements.push(
				new AvatarDOMComponent({
					user: {
						id: "",
					},
					width: avatarWidth,
					dashedOutline: false,
					isDarkMode,
					initials: users.length - usersToRender.length,
					background: colors.grey[200].substring(1),
					color: colors.grey[600].substring(1),
				}).el,
			);
		}
		userElements = userElements.concat(
			usersToRender.map(
				user =>
					new AvatarDOMComponent({
						user,
						width: avatarWidth,
						dashedOutline: user.isExternalInNote,
						isDarkMode,
					}).el,
			),
		);
		this.el = redom.el(this.avatarsWrapperElement, userElements);
	}

	update() {}
}
